/**
 * @file AddFoodPakage.jsx
 * @description Component for adding new food packages with validation and form handling.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { validateForm } from "utils/validation";
import { FoodPackageRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddFoodPakageForm from "./Components/AddFoodPakageForm";
import Fields from "../json/FoodPackageFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { Create } from 'adminApi/FoodpackageApi/Foodpackage.js';


const AddFoodPakage = () => {
    const { formdata } = Fields;
    const navigate = useNavigate();

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    // Manage input change with validation rules
    const { values, errors, handleChange, setErrors } = useFormChange(
        initialValues,
        FoodPackageRules
    );

    // Form submit handler with validation
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await Create({ data: formData });
        },
        (vals) => {
            const err = validateForm(vals, FoodPackageRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Food Package Created Successfully"
    );

    return (
        <>
            {(loadingSubmit) && <Spinner isSpinner={true} />}
            <AddFoodPakageForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Create Food Package"
            />
        </>
    );
};

export default AddFoodPakage;
